import React from 'react';

import { Button, Badge } from '@material-ui/core';
import { useSelector, useDispatch } from 'react-redux';
import { withStyles } from '@material-ui/core/styles';
import { confirmMaterialsDialog } from '../redux';

const StyledBadge = withStyles(theme => ({
  badge: {
    right: 15,
    top: 0,
    border: `2px solid ${theme.palette.background.paper}`,
    padding: '0 4px',
  },
}))(Badge);

const NotificationButton = ({ ...buttonStyle }) => {
  const dispatch = useDispatch();
  const status = useSelector(state => state);
  return (
    <StyledBadge
      badgeContent={status.tasks.data.confirmMaterials?.length}
      max={99}
      color="primary"
      overlap="rectangular"
    >
      <Button
        onClick={() => dispatch(confirmMaterialsDialog(true))}
        style={buttonStyle.buttonStyle}
        variant="contained"
      >
        Получени материали
      </Button>
    </StyledBadge>
  );
};

export default NotificationButton;
